// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"SearchInput_searchInputWrapper__pB3aJ","searchInput":"SearchInput_searchInput__ok6yQ","btnSearch":"SearchInput_btnSearch__h7SVu"};